(() => {
  const header = document.querySelector('[data-site-header]');
  const toggle = document.querySelector('[data-mobile-nav-toggle]');
  const menu = document.querySelector('[data-mobile-menu]');

  const closeMenu = () => {
    if (!toggle || !menu) return;
    toggle.setAttribute('aria-expanded', 'false');
    menu.hidden = true;
    document.body.classList.remove('menu-open');
  };

  if (toggle && menu) {
    toggle.addEventListener('click', () => {
      const open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!open));
      menu.hidden = open;
      document.body.classList.toggle('menu-open', !open);
    });

    menu.querySelectorAll('a').forEach((link) => link.addEventListener('click', closeMenu));
    window.addEventListener('resize', () => {
      if (window.innerWidth > 860) closeMenu();
    });
  }

  if (header) {
    const setSticky = () => header.classList.toggle('is-sticky', window.scrollY > 70);
    setSticky();
    window.addEventListener('scroll', setSticky, { passive: true });
  }
})();
